module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_25 (32).d5025e1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_25 (32).mp4
// module id = 807
// module chunks = 1